import { userSuccessRegisterAction } from "../userRegisterAction";
import { setStateToResetPasswordAction } from "../resetStatetePasswordAction";
import { $api } from "../../../services/request.config";

export const resetPasswordThunkAction =
    (input, resetPassword, onError) => async (dispatch) => {
        try {
            const response = await $api.post("/v1.0/auth/verify/socNumber", {
                socNumber: input.id,
            });
            if (response) {
                localStorage.setItem("userId", response.data.userId);
                localStorage.setItem("resetPassword", resetPassword);
                if (localStorage.getItem("resetPassword")) {
                    dispatch(setStateToResetPasswordAction());
                    dispatch(userSuccessRegisterAction({userId: response.data.userId, phoneNumber:response.data.phoneNumber}));
                }
                //
            }
        } catch (e) {
            if (e.response.status === 500 || e.response.status === 404) {
                return onError("Что-то пошло не так, повторите попытку позже");
            }
            onError(e.response.data);
        }
    };
